import React, { useEffect } from "react";
import {
  Drawer,
  Form,
  Input,
  Select,
  Switch,
  DatePicker,
  InputNumber,
  Divider,
  Button,
} from "antd";
import dayjs from "dayjs";
import ImageUpload from "../../components/image-upload/ImageUpload";
import { BANNER_STATUS_OPTIONS, PLACEMENT_OPTIONS } from "../../constants";

const { TextArea } = Input;
const { RangePicker } = DatePicker;

export default function BannerFormDrawer({
  open,
  onClose,
  onSubmit,
  initial,
  loading,
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      if (initial) {
        form.setFieldsValue({
          title: initial.title ?? "",
          subtitle: initial.subtitle ?? "",
          description: initial.description ?? "",
          imageUrl: initial.imageUrl ?? null,
          mobileImageUrl: initial.mobileImageUrl ?? null,
          ctaLabel: initial.ctaLabel ?? "",
          ctaUrl: initial.ctaUrl ?? "",
          ctaExternal: initial.ctaExternal ?? false,
          placement: initial.placement,
          sortOrder: initial.sortOrder ?? 0,
          status: initial.status ?? "DRAFT",
          textColor: initial.textColor ?? "",
          overlayOpacity: initial.overlayOpacity ?? null,
          dateRange:
            initial.startsAt && initial.endsAt
              ? [dayjs(initial.startsAt), dayjs(initial.endsAt)]
              : null,
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, initial]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const { dateRange, ...rest } = values;
      onSubmit({
        ...rest,
        startsAt: dateRange?.[0]?.toISOString() ?? null,
        endsAt: dateRange?.[1]?.toISOString() ?? null,
      });
    } catch (err) {}
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={initial ? "Баннер засах" : "Баннер нэмэх"}
      width={560}
      destroyOnClose
      styles={{ body: { paddingBottom: 80 } }}
      footer={
        <div className="d-flex justify-content-end gap-2">
          <Button onClick={onClose}>Болих</Button>
          <Button type="primary" onClick={handleSubmit} loading={loading}>
            {initial ? "Хадгалах" : "Нэмэх"}
          </Button>
        </div>
      }
    >
      <Form form={form} layout="vertical">
        {/* ── Үндсэн мэдээлэл ── */}
        <Divider orientation="left" plain>
          Үндсэн мэдээлэл
        </Divider>

        <div className="row g-3">
          <div className="col-8">
            <Form.Item
              name="title"
              label="Гарчиг"
              rules={[{ required: true, message: "Гарчиг оруулна уу" }]}
            >
              <Input placeholder="Баннерын гарчиг" />
            </Form.Item>
          </div>
          <div className="col-4">
            <Form.Item name="status" label="Төлөв" initialValue="DRAFT">
              <Select options={BANNER_STATUS_OPTIONS} />
            </Form.Item>
          </div>
        </div>

        <Form.Item name="subtitle" label="Дэд гарчиг">
          <Input placeholder="Дэд гарчиг (заавал биш)" />
        </Form.Item>

        <Form.Item name="description" label="Дэлгэрэнгүй тайлбар">
          <TextArea rows={3} placeholder="Тайлбар текст" />
        </Form.Item>

        {/* ── Зураг ── */}
        <Divider orientation="left" plain>
          Зураг
        </Divider>

        <div className="row g-3">
          <div className="col-6">
            <Form.Item
              name="imageUrl"
              label="Desktop зураг"
              rules={[{ required: true, message: "Зураг оруулна уу" }]}
            >
              <ImageUpload size={120} />
            </Form.Item>
          </div>
          {/* <div className="col-6">
            <Form.Item name="mobileImageUrl" label="Mobile зураг">
              <ImageUpload size={120} />
            </Form.Item>
          </div> */}
        </div>

        {/* ── CTA товч ── */}
        <Divider orientation="left" plain>
          CTA товч
        </Divider>

        <div className="row g-3">
          <div className="col-6">
            <Form.Item name="ctaUrl" label="Холбоос">
              <Input placeholder="/news/slug эсвэл https://..." />
            </Form.Item>
          </div>
          <div className="col-6">
            <Form.Item
              name="ctaExternal"
              label="Шинэ tab"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
          </div>
        </div>

        {/* ── Байршил & Тохиргоо ── */}
        <Divider orientation="left" plain>
          Байршил & Тохиргоо
        </Divider>

        <div className="row g-3">
          <div className="col-8">
            <Form.Item
              name="placement"
              label="Байршил"
              rules={[{ required: true, message: "Байршил сонгоно уу" }]}
            >
              <Select
                options={PLACEMENT_OPTIONS}
                placeholder="Байршил сонгох"
              />
            </Form.Item>
          </div>
          <div className="col-4">
            <Form.Item name="sortOrder" label="Дараалал" initialValue={0}>
              <InputNumber min={0} style={{ width: "100%" }} />
            </Form.Item>
          </div>
        </div>

        <Form.Item
          name="dateRange"
          label="Харуулах огноо (хоосон = хязгааргүй)"
        >
          <RangePicker showTime style={{ width: "100%" }} />
        </Form.Item>
      </Form>
    </Drawer>
  );
}
